var _style, _path, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#32A6DC;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "contenido-del-sitio-web"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "st0",
    d: "M0,0h55v55H0V0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 55,
    height: 55
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-layout-browser-page-website",
    transform: "translate(1.71875 1.71875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st2",
    d: "M45.5,30.9H6c-0.5,0-0.9-0.4-0.9-0.9V12.9C5.2,12.4,5.5,12,6,12h39.5c0.5,0,0.9,0.4,0.9,0.9 v17.2C46.4,30.6,46,30.9,45.5,30.9L45.5,30.9z M6.9,29.2h37.8V13.8H6.9V29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st2",
    d: "M23.2,36.1H10.3c-0.3,0-0.6-0.2-0.7-0.4s-0.2-0.6,0-0.9s0.4-0.4,0.7-0.4h12.9 c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C23.8,35.9,23.5,36.1,23.2,36.1L23.2,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st2",
    d: "M23.2,43H6c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4h17.2 c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C23.8,42.8,23.5,43,23.2,43L23.2,43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st2",
    d: "M18.9,46.4H6c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4h12.9 c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C19.5,46.2,19.2,46.4,18.9,46.4L18.9,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st2",
    d: "M6.9,36.1H6c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4h0.9 c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C7.5,35.9,7.2,36.1,6.9,36.1L6.9,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st2",
    d: "M23.2,46.4h-0.9c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4h0.9 c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C23.8,46.2,23.5,46.4,23.2,46.4L23.2,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    className: "st2",
    d: "M45.5,36.1H32.7c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4 h12.9c0.3,0,0.6,0.2,0.7,0.4s0.2,0.6,0,0.9S45.9,36.1,45.5,36.1L45.5,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    className: "st2",
    d: "M45.5,43H28.4c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4h17.2 c0.3,0,0.6,0.2,0.7,0.4s0.2,0.6,0,0.9S45.9,43,45.5,43L45.5,43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "st2",
    d: "M23.2,39.5H6c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9C5.4,38,5.7,37.8,6,37.8h17.2 c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C23.8,39.4,23.5,39.5,23.2,39.5L23.2,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    className: "st2",
    d: "M45.5,39.5H28.4c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4 h17.2c0.3,0,0.6,0.2,0.7,0.4s0.2,0.6,0,0.9S45.9,39.5,45.5,39.5L45.5,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st2",
    d: "M41.2,46.4H28.4c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4 h12.9c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C41.8,46.2,41.6,46.4,41.2,46.4L41.2,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    className: "st2",
    d: "M29.2,36.1h-0.9c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4 h0.9c0.3,0,0.6,0.2,0.7,0.4c0.2,0.3,0.2,0.6,0,0.9C29.8,35.9,29.5,36.1,29.2,36.1L29.2,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    className: "st2",
    d: "M45.5,46.4h-0.9c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.4-0.4,0.7-0.4 h0.9c0.3,0,0.6,0.2,0.7,0.4s0.2,0.6,0,0.9S45.9,46.4,45.5,46.4L45.5,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    className: "st2",
    d: "M49,0H2.6C1.2,0,0,1.2,0,2.6L0,49c0,1.4,1.2,2.6,2.6,2.6H49c1.4,0,2.6-1.2,2.6-2.6V2.6 C51.6,1.2,50.4,0,49,0L49,0z M49.8,49c0,0.5-0.4,0.9-0.9,0.9H2.6c-0.5,0-0.9-0.4-0.9-0.9V8.6h48.1V49z M49.8,6.9H1.7V2.6 c0-0.5,0.4-0.9,0.9-0.9H49c0.5,0,0.9,0.4,0.9,0.9V6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14_",
    className: "st2",
    d: "M5.2,3.4H4.3c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9C5.6,5.2,6,4.8,6,4.3 C6,3.8,5.6,3.4,5.2,3.4L5.2,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_15_",
    className: "st2",
    d: "M9.5,3.4H8.6c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9c0.5,0,0.9-0.4,0.9-0.9 C10.3,3.8,9.9,3.4,9.5,3.4L9.5,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16_",
    className: "st2",
    d: "M13.8,3.4h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9c0.5,0,0.9-0.4,0.9-0.9 C14.6,3.8,14.2,3.4,13.8,3.4L13.8,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17_",
    className: "st2",
    d: "M47.3,3.4h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9c0.5,0,0.9-0.4,0.9-0.9 C48.1,3.8,47.7,3.4,47.3,3.4L47.3,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18_",
    className: "st2",
    d: "M43,3.4H22.3c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9H43c0.5,0,0.9-0.4,0.9-0.9 C43.8,3.8,43.4,3.4,43,3.4L43,3.4z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.82c6cbf012b51785fca28c56600492d9.svg";
export { ForwardRef as ReactComponent };